import * as React from "react";
import Layout from "../components/Layout.js";
import ContactLanding from "../components/contact/index.js";

const Contact = () => {
    return (
      <Layout>
          <ContactLanding 
            title={'Let\'s chat'}
            subtitle={'Whether it\'s questions, partnerships, or feedback, we\'re keen to hear from you!'}
            subtitle_two={'Alternatively, you can email us at:'}
            email={'sydney@usydcommstem.org'}
            punctuation={'!'}
        />
      </Layout>

      );

};

export default Contact;
